import React, { Component } from 'react';
import { withRouter } from '../../../util/withRouter';

// Import Style
import '../style.scss';

const INSTALL_PATH = process.env.RUN_ENV === 'production' ?
  'https://uboard.releasemanagement.app/integration/not-installed.html' :
  'https://uboard-stg.releasemanagement.app/integration/not-installed.html';

class AkbPage extends Component {
  render() {
    return (
      <div className='main akb'>        
        <div className='iframe_content'>
          <iframe
            src={INSTALL_PATH}
            border="0"
          ></iframe>
        </div>
      </div>
    );
  }
}

export default withRouter(AkbPage);
